export function getZoomAnimation (element, settings) {
    const animation = {
        scale: settings.zoom / 100,
    }
    if (settings.withFade ?? true) {
        animation.opacity = 0
    }
    return animation
}
